export function operacaoLiberacaoRemotaInRequest(params = {}) {
  return {
    type: '@operacaoliberacaoremota/OPERACAOLIBERACAOREMOTA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoLiberacaoRemota(movi_codigo) {
  return {
    type: '@operacaoliberacaoremota/FIND_OPERACAOLIBERACAOREMOTA',
    payload: { movi_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoliberacaoremota/FAILED_REQUEST',
  };
}

export function deleteOperacaoLiberacaoRemota(movi_codigo, params) {
  return {
    type: '@operacaoliberacaoremota/DELETE_OPERACAOLIBERACAOREMOTA',
    payload: { movi_codigo, params },
  };
}

export function updateOperacaoLiberacaoRemota(operacaoliberacaoremota, params) {
  return {
    type: '@operacaoliberacaoremota/UPDATE_OPERACAOLIBERACAOREMOTA',
    payload: { operacaoliberacaoremota, params },
  };
}

export function storeOperacaoLiberacaoRemota(operacaoliberacaoremota, params) {
  return {
    type: '@operacaoliberacaoremota/STORE_OPERACAOLIBERACAOREMOTA',
    payload: { operacaoliberacaoremota, params },
  };
}

export function successInRequest(
  operacaoliberacaoremota,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoliberacaoremota/SUCCESS_IN_REQUEST',
    payload: { operacaoliberacaoremota, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoliberacaoremota) {
  return {
    type: '@operacaoliberacaoremota/SUCCESS_REQUEST',
    payload: { operacaoliberacaoremota },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoliberacaoremota/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoliberacaoremota/RECORD_FILTERING',
    payload: { params },
  };
}
